import React, { useId } from "react";
import InputField from "./InputField";

// Texto libre con sugerencias: un rol nuevo se puede escribir directamente.
const RolCombobox = ({
  label = "Rol",
  value,
  onChange,
  roles = [],
  placeholder = "Selecciona o escribe un rol",
  maxLength = 80,
  disabled = false,
}) => {
  const listaId = useId();
  return (
    <div>
      <InputField
        label={label}
        value={value}
        list={listaId}
        maxLength={maxLength}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
      />
      <datalist id={listaId}>
        {roles.map((rol) => (
          <option key={rol._id || rol.nombre} value={rol.nombre} />
        ))}
      </datalist>
    </div>
  );
};

export default RolCombobox;
